module.exports = __webpack_public_path__ + "static/media/Latin-Merriweather-Bold.46eab112.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/merriweather/Latin-Merriweather-Bold.ttf
// module id = 520
// module chunks = 0